export class Terminal {
    portoID: number;
    terminalID: number;
    nomePorto: string;
    nomeTerminal: string;
    latitude: string;
    longitude: string;
    podeExcluir: boolean;
}